
import React from 'react';
import { Navigate } from 'react-router-dom';

type Props = {
  children: React.ReactNode;
  requiredRole?: string;
};

const ManagerRoute = ({ children, requiredRole }: Props) => {
  const token = localStorage.getItem('token');
  const currentRole = localStorage.getItem('role');

  // Redirect unauthenticated users to login.
  if (!token) {
    return <Navigate to="/Login" replace />;
  }

  // If no specific role is required, allow any authenticated user.
  if (!requiredRole) {
    return <>{children}</>;
  }

  // Allow only the role required by this route.
  if (currentRole !== requiredRole) {
    return <Navigate to="/public-report" replace />;
  }

  return <>{children}</>;
};

export default ManagerRoute;
